import script from "./RankInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./RankInfo.vue?vue&type=script&setup=true&lang=js"

import "./RankInfo.vue?vue&type=style&index=0&id=2e231b8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e231b8a"]])

export default __exports__